<template>
  <div class='progress-bar'>
    <ProgressBarItem
      v-for="(question, index) in sceneQuestions"
      :key="index"
      :status='status[question.statusKey]'
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import ProgressBarItem from '/src/components/ProgressBarItem.vue';

export default {
  components: {
    ProgressBarItem
  },
  computed: {
    ...mapFields([
      'ui.sceneQuestions',
      'scene.status',
    ]),
  },
};
</script>
